import { InfoIcon } from 'lucide-react'

import {
  TRIAL_PAGE_GRANT,
  useIsTrialAccount,
  useSummary,
} from '@/modules/account'

const NoteBox = ({ children }: { children: React.ReactNode }) => (
  <div
    role="note"
    className="flex items-start gap-3 rounded-md border px-4 py-3 text-sm"
  >
    <InfoIcon className="text-brand mt-0.5 size-4 shrink-0" aria-hidden />
    <p>{children}</p>
  </div>
)

export const TrialUploadNote = () => {
  const isTrial = useIsTrialAccount()
  const summary = useSummary()
  // Before the page count arrives, any number shown here would be wrong.
  if (!isTrial || !summary) return null

  const pagesLeft = Math.max(0, summary.pagesCredits)
  if (pagesLeft === 0) {
    return (
      <NoteBox>
        <strong className="font-semibold">Your trial pages are used up.</strong>{' '}
        Files you add now are kept and extracted after you upgrade.
      </NoteBox>
    )
  }

  return (
    <NoteBox>
      <strong className="font-semibold">
        Your trial extracts the first {TRIAL_PAGE_GRANT} pages you send, in
        upload order.
      </strong>{' '}
      If a statement range falls beyond the first {TRIAL_PAGE_GRANT} pages, it
      is excluded. All additional pages are kept but not extracted.
    </NoteBox>
  )
}
